import { render, staticRenderFns } from "./shopping-bag.vue?vue&type=template&id=d2afbb1e&scoped=true&"
import script from "./shopping-bag.vue?vue&type=script&lang=js&"
export * from "./shopping-bag.vue?vue&type=script&lang=js&"
import style0 from "./shopping-bag.vue?vue&type=style&index=0&id=d2afbb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2afbb1e",
  null
  
)

export default component.exports